import React, { useEffect, useState, useRef, useMemo, Fragment } from "react";
import { Resizable } from "react-resizable";
import useUrlParams from "../../hooks/useUrlParams";
import useDashboard from "../../hooks/useDashboard";
import "../../../command_center/components/center/modals/console/Console.scss";
import { ConsoleOutputList, Row } from "./ConsoleOutputList";
import { FixedSizeList as List } from "react-window";
import ShimmerMenuList from "../../../CommonComponents/SimmerEffectDesign/ShimmerMenu";
import JsonEditor from "../../../CommonComponents/json_editor/JsonEditor";
import CustomToolTip from "../../../CommonComponents/CustomToolTip";
import { CloseIcon, DownloadIcon } from "../../../command_center/components/center/modals/Svgs";

// in this fuile unsed variable/state and the props might required in the future

const ConsoleOutputSection = ({ error, commandDetails, getCommandDetails, set_resizing, consoleTableColumns, isTableWidth, allFilters, isFrozen, setIsFrozen }) => {
  const { dashboard } = useUrlParams();
  const listRef = useRef(null);

  const [outputModalSize, setOutputModalSize] = React.useState({
    width: 500,
    height: window.innerHeight - 234,
    resizing: false,
  });
  const [selectedRow, setSelectedRow] = React.useState({
    CommandUid: "",
    selectedRow: "",
    commandIndexs: [],
    type: ""
  });
  const [commandType, setCommandType] = React.useState("");
  const [hexString, setHexString] = React.useState("");
  const [foundPayload, setFoundPayload] = React.useState("");
  const [outputModalOptions, setOutputModalOptions] = useState({ contents: false, json: true, bytes: false, messages: false });
  const [isOutputModalVisible, setIsOutputModalVisible] = useState(false);
  const [entries, setEntries] = useState([]);
  const showCorrespondingTask = true;
  const [showNoMessage, setShowNoMessage] = useState(false);
  const [hasCheckedMessage, setHasCheckedMessage] = useState(false);
  const [dataCount, setDataCount] = useState(0);
  const { scenario } = useDashboard();
  const scenario_completed = useMemo(() => scenario?.status === 'SimulationCompleted', [scenario?.status]);

  useEffect(() => {
    if (commandType && commandDetails) {
      updateHexAndPayload();
    }
  }, [commandType, commandDetails]);

  useEffect(() => {
    const clearFormFields = () => {
      setSelectedRow({ CommandUid: "", selectedRow: "", commandIndexs: [], type: "" });
      setHexString("");
      setFoundPayload("");
      setCommandType("");
      setIsOutputModalVisible(false);
    };
    window.addEventListener("clearFormFields", clearFormFields);
    return () => window.removeEventListener("clearFormFields", clearFormFields);
  }, []);

  useEffect(() => {
    const handleOpenConsole = () => setIsFrozen(false);
    window.addEventListener('openGenericSimulatorConsole', handleOpenConsole);
    return () => window.removeEventListener('openGenericSimulatorConsole', handleOpenConsole);
  }, []);

  useEffect(() => {
    const updateHeight = () => setOutputModalSize((prev) => ({ ...prev, height: window.innerHeight - 234 }));
    window.addEventListener("resize", updateHeight);
    updateHeight();
    return () => window.removeEventListener("resize", updateHeight);
  }, []);

  const show_selected_output_details = (selected_command, entries) => {
    if (selected_command) {
      const { type, CommandUid, uniqueId } = selected_command;
      setCommandType(type);
      const positions = entries?.reduce((acc, output, index) => {
        if (output.CommandUid === CommandUid) acc.push(index);
        return acc;
      }, []);
      const selected_row = entries.indexOf(selected_command);
      const already_selected = selected_row === selectedRow.selectedRow;
      const selectedCommandTye = selected_command?.type;
      setSelectedRow({
        CommandUid: already_selected ? "" : uniqueId,
        selectedRow: already_selected ? "" : selected_row,
        commandIndexs: already_selected ? [] : positions,
        type: already_selected ? "" : selectedCommandTye
      });
      if (!already_selected) updateHexAndPayload();
      else { setHexString(""); setFoundPayload(""); setCommandType(""); }
    } else {
      setHexString("");
      setFoundPayload("");
      setCommandType("");
      setSelectedRow({ CommandUid: "", selectedRow: "", commandIndexs: [], type: "" });
    }
  };

  const updateHexAndPayload = () => {
    let base64String = "";
    let payload = "";
    if (commandDetails && commandDetails.data) {
      commandDetails.data.forEach((command) => {
        if (command.type === commandType) {
          base64String = command.CommandDetails.completeFrame || "";
          payload = command.CommandDetails || "";
        }
      });
    }
    delete payload.payloadBytes;
    delete payload.completeFrame;
    const base64ToHex = (str) => {
      if (!str) return "";
      const raw = atob(str);
      let result = "";
      for (let i = 0; i < raw.length; i++) {
        const hex = raw.charCodeAt(i).toString(16);
        result += hex.length === 2 ? hex : "0" + hex;
        result += " ";
      }
      return result.toUpperCase();
    };
    setHexString(base64ToHex(base64String));
    setFoundPayload(payload);
    setIsOutputModalVisible(true);
  };

  const onResizeHeight = (event, { node, size, handle }) => {
    event.stopPropagation();
    if (size.height >= 100 && size.height <= 500) {
      setOutputModalSize((prev) => ({ ...prev, height: size.height, resizing: "height" }));
    }
  };
  const onResizeWidth = (event, { node, size, handle }) => {
    event.stopPropagation();
    if (size.width >= 200 && size.width <= 1000) {
      setOutputModalSize((prev) => ({ ...prev, width: size.width, resizing: "width" }));
    }
  };
  const onResizeStop = (event) => {
    event.stopPropagation();
    set_resizing(false);
    setOutputModalSize((prev) => ({ ...prev, resizing: false }));
  };
  const onResizeStart = (event) => {
    event.stopPropagation();
    set_resizing(true);
  };

  const handleTabChange = (selectedKey) => {
    setOutputModalOptions({ contents: false, json: false, bytes: false, messages: false, [selectedKey]: true });
  };

  useEffect(() => {
    if (commandDetails && selectedRow) {
      const correspondingCommand = commandDetails?.data?.find(entry => entry?.type !== selectedRow?.type);
      setShowNoMessage(!correspondingCommand);
      setHasCheckedMessage(true);
    }
  }, [commandDetails, selectedRow]);

  const itemData = useMemo(
    () => ({
      entries,
      selectedRow,
      getCommandDetails,
      show_selected_output_details,
      consoleTableColumns,
      setIsOutputModalVisible,
      isOutputModalVisible,
      commandDetails,
      showCorrespondingTask
    }),
    [entries, selectedRow, getCommandDetails, show_selected_output_details, consoleTableColumns, commandDetails, showCorrespondingTask]
  );

  const removeSelection = () => {
    setIsOutputModalVisible(false);
    setSelectedRow({ CommandUid: "", selectedRow: "", commandIndexs: [], type: "" });
    setIsFrozen(false);
  };

  const downloadOutputDetails = () => {
    if (!hexString || !foundPayload) return;
    const data = { "Packet Details": foundPayload, "Raw Bytes": hexString };
    const jsonString = JSON.stringify(data, null, 2);
    const blob = new Blob([jsonString], { type: 'application/json' });
    const element = document.createElement('a');
    element.href = URL.createObjectURL(blob);
    element.download = `output_details_${selectedRow?.CommandUid || 'data'}.json`;
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
    URL.revokeObjectURL(element.href);
  };

  useEffect(() => {
    const handleRemoveSelection = () => removeSelection();
    window.addEventListener("removeSelection", handleRemoveSelection);
    return () => window.removeEventListener("removeSelection", handleRemoveSelection);
  }, []);

  const triggerRemoveSelection = () => window.dispatchEvent(new CustomEvent("removeSelection"));

  return (
    <>
      <div
        style={{ maxWidth: dashboard === "operate" ? `${isTableWidth}px` : `auto` }}
        className={`right__panel__body__content__container ${isOutputModalVisible && "outputModalVisibleShortHeight"} right__panel__table__width modal__scrollbar__white__horizontal`}
      >
        <div className="content__container__table__header gap-2 right__panel__table__width" style={{ width: dashboard === "operate" ? `${isTableWidth}px` : `auto` }}>
          {dashboard !== "operate" && consoleTableColumns?.map((item) => (
            item.isSelected && item?.dashboard !== 'operate' && (
              <div key={item.label} className="d-flex align-items-center justify-content-start-gap" style={{ width: `${item.width}px` }}>
                <span>{item?.isSvg ? item.svg : item?.label}</span>
              </div>
            )
          ))}
          {dashboard === "operate" && consoleTableColumns?.map((item) => (
            item.isSelected && (
              <div key={item.label} className="d-flex align-items-center justify-content-start-gap" style={{ width: `${item.width}px` }}>
                <span>{item?.isSvg ? item.svg : item?.label}</span>
              </div>
            )
          ))}
        </div>
        <Resizable
          className="position-relative right__panel__table__width"
          style={{ width: dashboard === "operate" ? `${isTableWidth}px` : `auto`, ...(entries?.length === 0 || !entries ? { overflowY: "hidden" } : {}) }}
          height="calc(100vh - 234px)"
          onResizeStop={onResizeStop}
          onResizeStart={onResizeStart}
          onResize={onResizeHeight}
          handle={(handleAxis, ref) => (
            <div ref={ref} className={`container__table__body__resize__handler ${outputModalSize.resizing === "height" && "active"} handle-${handleAxis}`} />
          )}
        >
          <div style={{ height: "calc(100vh - 234px)", overflowY: (entries?.length === 0 || !entries) ? "hidden" : "" }}>
            <div className="content__container__table__body">
              {(isFrozen && !scenario_completed && dataCount > 0) && (
                <div className="unread_messages_div">
                  <span>{dataCount + " new messages"}</span>
                </div>
              )}
              <ConsoleOutputList
                height={outputModalSize.height}
                getCommandDetails={getCommandDetails}
                show_selected_output_details={show_selected_output_details}
                selectedRow={selectedRow}
                consoleTableColumns={consoleTableColumns}
                isOutputModalVisible={isOutputModalVisible}
                setIsOutputModalVisible={setIsOutputModalVisible}
                allFilters={allFilters}
                setEntries={setEntries}
                entries={entries}
                setIsFrozen={setIsFrozen}
                isFrozen={isFrozen}
                dataCount={dataCount}
                setDataCount={setDataCount}
                setSelectedRow={setSelectedRow}
              />
            </div>
          </div>
        </Resizable>
      </div>
      {isOutputModalVisible && (
        <div className="output__modal">
          <div className="output__modal__header__console">
            <div className="output__modal__header__console__options__container">
              <button className={`output__modal__header__console__option ${outputModalOptions.json ? "active" : ""}`} onClick={() => handleTabChange('json')}>CONTENTS</button>
              <button className={`output__modal__header__console__option ${outputModalOptions.messages ? "active" : ""}`} onClick={() => handleTabChange('messages')}>MESSAGES</button>
            </div>
            <div className="output__modal__header__console__actions_btns">
              {(hexString && foundPayload) && (
                <CustomToolTip title="Download Output" placement="top">
                  <button onClick={downloadOutputDetails}><DownloadIcon /></button>
                </CustomToolTip>
              )}
              <button onClick={triggerRemoveSelection}><CloseIcon /></button>
            </div>
          </div>
          <div className={`right__panel__body__content__container ${isOutputModalVisible && "outputModalVisibleShortHeight"} right__panel__table__width modal__scrollbar__white__horizontal`}>
            <div className="output__modal__body__container">
              {outputModalOptions?.json && (
                <Fragment>
                  <Resizable
                    className="position-relative"
                    width={outputModalSize.width}
                    onResizeStop={onResizeStop}
                    onResizeStart={onResizeStart}
                    onResize={onResizeWidth}
                    handle={(handleAxis, ref) => (
                      <div ref={ref} className={`output__modal__left__resize__handler ${outputModalSize.resizing === "width" && "active"} handle-${handleAxis}`} />
                    )}
                  >
                    <div>
                      <div className="output__modal__left__section" style={{ width: outputModalSize.width }} onMouseDown={(e) => e.stopPropagation()}>
                        <span>Packet Details:</span>
                        {foundPayload ? (
                          <JsonEditor value={JSON.stringify({ payload: foundPayload }, null, 2)} editable={false} backgroundColor="transparent" />
                        ) : (
                          "Not available"
                        )}
                      </div>
                    </div>
                  </Resizable>
                  <div className="output__modal__right__section" onMouseDown={(e) => e.stopPropagation()}>
                    <span>Raw Bytes:</span>
                    <div onMouseDown={(e) => e.stopPropagation()} onSelectStart={(e) => e.stopPropagation()}>
                      {hexString ? hexString : "Not available"}
                    </div>
                  </div>
                </Fragment>
              )}
            </div>
            {!hasCheckedMessage && <ShimmerMenuList />}
            {outputModalOptions?.messages && hasCheckedMessage && (
              showNoMessage ? (
                <div className="output__div__message__container">No associated message found.</div>
              ) : (
                <div style={{ minWidth: dashboard === "operate" ? `${isTableWidth}px` : `auto`, marginTop: '8px' }} className="right__panel__body__content__container right__panel__table__width modal__scrollbar__white__horizontal">
                  <List ref={listRef} itemData={itemData} height={35} itemCount={1} itemSize={35} width="100%">{Row}</List>
                </div>
              )
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default ConsoleOutputSection;
